var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 500 500",
    height: "500px",
    id: "Layer_1",
    viewBox: "0 0 500 500",
    width: "500px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 363.459,
    x2: 397.066,
    y1: 82.696,
    y2: 82.696
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M397.066,82.696c11.988,0,21.689,9.811,21.689,21.939",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 418.756,
    x2: 418.756,
    y1: 104.636,
    y2: 453.047
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M418.756,453.047c0,12.114-9.701,21.953-21.689,21.953",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 397.066,
    x2: 102.932,
    y1: 475,
    y2: 475
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M102.932,475c-11.975,0-21.688-9.839-21.688-21.953",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 81.244,
    x2: 81.244,
    y1: 453.047,
    y2: 104.636
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M81.244,104.636c0-12.128,9.713-21.939,21.688-21.939",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 102.932,
    x2: 131.906,
    y1: 82.696,
    y2: 82.696
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    points: "   342.859,50.625 286.991,50.625 286.991,45.851  ",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M286.991,45.851c0-11.542-9.24-20.851-20.571-20.851",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 266.42,
    x2: 233.621,
    y1: 25,
    y2: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M233.621,25c-11.359,0-20.627,9.309-20.627,20.851",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    points: "   212.994,45.851 212.994,50.625 157.181,50.625  ",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M157.181,50.625c-11.374,0-20.599,9.35-20.599,20.878",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    points: "   136.582,71.503 136.582,115.857 363.459,115.857 363.459,71.503  ",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M363.459,71.503c0-11.528-9.184-20.878-20.6-20.878",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 137.6,
    x2: 156.218,
    y1: 221.173,
    y2: 238.492
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 190.412,
    x2: 156.218,
    y1: 200.699,
    y2: 238.492
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 222.875,
    x2: 362.44,
    y1: 223.462,
    y2: 223.462
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 222.875,
    x2: 362.44,
    y1: 392.56,
    y2: 392.56
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.6131,
    strokeWidth: 10,
    x1: 222.875,
    x2: 362.44,
    y1: 309.239,
    y2: 309.239
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.5a5cf341.svg";
export { ForwardRef as ReactComponent };